<template>
  <myDialog :isDialog="isDialog" :title="isEdit ? '编辑预约' : '新增预约'" :width="'500px'" @handleClose="handleClose">
    <template slot="content">
      <el-form :model="formData" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formData.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idNumber">
          <el-input v-model="formData.idNumber" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formData.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="分组" prop="workInjuryCategoryCode">
          <el-select v-model="formData.workInjuryCategoryCode" placeholder="请选择分组" @change="handleCategoryChange" style="width: 100%;">
            <el-option
              v-for="item in groupList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约时间" prop="subscribeTime">
          <el-date-picker
            v-model="formData.subscribeTime"
            type="date"
            placeholder="请选择预约时间"
            style="width: 100%;"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </template>
    <template slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">确定</el-button>
    </template>
  </myDialog>
</template>

<script>
import { addSubscribe, updateSubscribe } from '@/api/industrialInjury/subscribe'
import { getListByDictType } from '@/api/sys/dictData'

export default {
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        name: '',
        idNumber: '',
        phone: '',
        workInjuryCategoryCode: '',
        workInjuryCategoryName: '',
        subscribeTime: ''
      },
      groupList: [],
      loading: false,
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idNumber: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        workInjuryCategoryCode: [
          { required: true, message: '请选择分组', trigger: 'change' }
        ],
        subscribeTime: [
          { required: true, message: '请选择预约时间', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getGroupList()
  },
  watch: {
    editData: {
      handler(newVal) {
        if (newVal && this.isEdit) {
          console.log('原始editData:', newVal)
          console.log('subscribeTime原始值:', newVal.subscribeTime)
          console.log('subscribeTime类型:', typeof newVal.subscribeTime)
          
          // 处理日期字段
          const processedData = { ...newVal }
          
          // 确保 subscribeTime 是字符串格式
          if (processedData.subscribeTime) {
            processedData.subscribeTime = this.formatDateForPicker(processedData.subscribeTime)
            console.log('处理后的subscribeTime:', processedData.subscribeTime)
          }
          
          this.formData = processedData
        }
      },
      immediate: true,
      deep: true
    },
    isDialog(val) {
      if (!val && this.isEdit) {
        this.$refs.form && this.$refs.form.resetFields()
      }
    }
  },
  methods: {
     // 格式化日期为日期选择器需要的格式
  formatDateForPicker(dateValue) {
    if (!dateValue) return ''
    
    console.log('formatDateForPicker 输入:', dateValue, '类型:', typeof dateValue)
    
    // 如果已经是字符串，检查格式
    if (typeof dateValue === 'string') {
      // 尝试解析这个字符串
      const date = new Date(dateValue)
      if (!isNaN(date.getTime())) {
        // 格式化为 yyyy-MM-dd HH:mm:ss
        return this.formatDateTime(date)
      }
      return dateValue
    }
    
    // 如果是 Date 对象
    if (dateValue instanceof Date) {
      return this.formatDateTime(dateValue)
    }
    
    // 如果是时间戳
    if (typeof dateValue === 'number') {
      const date = new Date(dateValue)
      if (!isNaN(date.getTime())) {
        return this.formatDateTime(date)
      }
    }
    
    // 如果是其他对象，尝试 JSON.stringify 然后解析
    try {
      const dateStr = JSON.stringify(dateValue)
      const date = new Date(dateStr)
      if (!isNaN(date.getTime())) {
        return this.formatDateTime(date)
      }
    } catch (error) {
      console.warn('无法解析日期:', dateValue)
    }
    
    return ''
  },
  
  // 格式化日期为 yyyy-MM-dd HH:mm:ss
  formatDateTime(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  },
    async getGroupList() {
      const res = await getListByDictType('industrial_injury_work_injury_category')
      if (res?.code === 200) {
        this.groupList = res.data || []
      }
    },
    handleCategoryChange(value) {
      const group = this.groupList.find(item => item.dictValue === value)
      if (group) {
        this.formData.workInjuryCategoryName = group.dictLabel
      }
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          const api = this.isEdit ? updateSubscribe : addSubscribe;
          api(this.formData).then(res => {
            if (res && res.code === 200) {
              this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
              this.$emit('success')
              this.handleClose()
            } else {
              // this.$message.error(res.msg || '操作失败')
            }
          }).catch(err => {
            console.error('请求出错', err)
            // this.$message.error('操作失败')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    handleClose() {
      this.$emit('handleClose')
      this.$refs.form && this.$refs.form.resetFields()
      this.formData = {
        name: '',
        idNumber: '',
        phone: '',
        workInjuryCategoryCode: '',
        workInjuryCategoryName: '',
        subscribeTime: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
